<template>
	<div class="b-border">
		<p class="d-flex align-items-center justify-content-between">
			<span class="mw-90">
				{{ showIndex ? index + label + asterisk : label + asterisk }}
				<small>{{ optional }}</small>
			</span>

			<a class="right" @click="add" v-if="!$root.isMobile()">Anexar</a>

			<span v-if="$root.isMobile()">
				<img src="@/assets/images/icons/attach.svg" class="right mr-3" @click="add" />
				<img src="@/assets/images/icons/camera.svg" class="right" @click="addPicture" />
			</span>
		</p>

		<span v-for="(file, index) in pendingFiles" :key="'pending-' + index" class="file">
			<div class="delete" @click="removePendingFile(file)"></div>
			{{ formatDocumentName(file) }}
		</span>

		<span v-for="(file, index) in processedUploadedFiles" :key="'uploaded-' + index" class="file">
			<div class="delete" @click="confirm(file, 'uploadedDocuments')"></div>
			{{ formatDocumentName(file) }}
		</span>

		<small class="error text-danger" v-if="error">
			Formato do arquivo não suportado! Formatos aceitos: {{ supportedExtensions.join(", ") }}.
		</small>

		<small class="error text-danger" v-if="errorFile">Arquivo já existe ou erro ao anexar arquivo.</small>

		<input type="file" ref="camera" @change="getPicture" style="display: none" accept="image/*" capture>
		<input type="file" ref="input" @change="changeFiles" style="display: none"
			:accept="supportedExtensions.join(',')" multiple>
	</div>
</template>

<script>
import { fileTypeToFormKey } from "@/utils/fileFormKey";

export default {
	name: "FilesComponent",
	props: {
		label: String,
		subLabel: String,
		required: Boolean,
		files: { type: [Array, Object] },
		uploadedFiles: { type: [Array, Object] },
		fileType: String,
		showIndex: Boolean,
		loopIndex: Number,
		modalId: {
			type: String,
			default: "modal-confirm"
		}
	},
	data() {
		return {
			errorFile: false,
			error: false,
			supportedExtensions: ["pdf", "docx", "doc", "jpg", "jpeg", "png"],
		};
	},
	methods: {
		getFileTimestamp() {
			const now = new Date();
			const min = String(now.getMinutes()).padStart(2, "0");
			const sec = String(now.getSeconds()).padStart(2, "0");
			return `${min}${sec}`;
		},
		fileWithTimestampName(file) {
			const lastDot = file.name.lastIndexOf(".");
			const baseName = lastDot >= 0 ? file.name.substring(0, lastDot) : file.name;
			const ext = lastDot >= 0 ? file.name.substring(lastDot) : "";
			const newName = `${baseName}_${this.getFileTimestamp()}${ext}`;
			return new File([file], newName, {
				type: file.type,
				lastModified: file.lastModified,
			});
		},
		add() {
			this.$refs.input.click();
		},
		addPicture() {
			this.$refs.camera.click();
		},
		remove(file) {
			this.files.splice(this.files.indexOf(file), 1);
		},
		confirm(file, type) {
			this.$store.commit("setConfirmForm", {
				form: this.$vnode.data.ref,
				key: file,
				type,
				fileType: this.fileType,
				formKey: this.loopIndex,
			});
			this.$bvModal.show(this.modalId);
		},
		async getPicture() {
			this.error = false;
			this.errorFile = false;
			const file = this.$refs.camera.files[0];

			const extension = file.name.split(".").pop();

			if (this.supportedExtensions.indexOf(extension) === -1) {
				this.error = true;
				return;
			}

			const fileToAdd = this.fileWithTimestampName(file);
			const wasAdded = await this.$store.dispatch("addPendingFile", {
				file: fileToAdd,
				fileType: this.fileType,
				loopIndex: this.loopIndex,
			});

			if (wasAdded) {
				this.files.push(fileToAdd);
			} else {
				this.errorFile = true;
				setTimeout(() => {
					this.errorFile = false;
				}, 3000);
			}

			this.$nextTick(() => {
				this.$forceUpdate();
			});
		},
		removePendingFile(pendingFile) {
			this.$store.dispatch("removePendingFile", {
				file: pendingFile.file || pendingFile,
				fileType: this.fileType,
				loopIndex: this.loopIndex,
			});

			const fileToRemove = pendingFile.file || pendingFile;
			const index = this.files.findIndex((f) => f.name === fileToRemove.name);
			if (index !== -1) {
				this.files.splice(index, 1);
			}

			this.$nextTick(() => {
				this.$forceUpdate();
			});
		},
		async changeFiles() {
			this.error = false;
			this.errorFile = false;
			const files = Array.from(this.$refs.input.files);

			// se não houver arquivos, não faz nada (quando o usuário cancela o upload)
			if (files.length === 0) {
				return;
			}

			for (const file of files) {
				const extension = file.name.split(".").pop().toLowerCase();

				if (this.supportedExtensions.indexOf(extension) === -1) {
					this.error = true;
					continue;
				}

				const fileToAdd = this.fileWithTimestampName(file);
				const wasAdded = await this.$store.dispatch("addPendingFile", {
					file: fileToAdd,
					fileType: this.fileType,
					loopIndex: this.loopIndex,
				});

				if (wasAdded) {
					this.files.push(fileToAdd);
				} else {
					this.errorFile = true;
					setTimeout(() => {
						this.errorFile = false;
					}, 3000);
				}
			}

			this.$nextTick(() => {
				this.$forceUpdate();
			});
		},
		formatDocumentName(file) {
			let fileName = null;

			if (file.file && file.file.name) {
				fileName = file.file.name;
			} else if (file.name) {
				fileName = file.name;
			} else if (file.filename) {
				fileName = file.filename;
			}

			if (fileName) {
				return fileName;
			}

			return "File uploaded";
		},

		getFormKey() {
			return fileTypeToFormKey(this.fileType);
		}
	},
	filters: {
		limitName(name, mobile) {
			const limit = mobile ? 30 : 40;

			if (name.length > limit) {
				return name.substring(0, limit) + "...";
			}

			return name;
		},
	},
	computed: {
		index() {
			return this.$parent.$children.indexOf(this) + 1 + ". ";
		},
		asterisk() {
			return this.required ? "*" : "";
		},
		optional() {
			if (this.subLabel) {
				return `(${this.subLabel})`;
			}

			return !this.required ? "(se houver)" : "";
		},
		pendingFiles() {
			const form = this.getFormKey();

			const allPendingFiles = this.$store.state.form.pendingFiles[form] || [];

			if ((this.fileType === "cpf" || this.fileType === "address_partners" || this.fileType === "representative") &&
				this.loopIndex !== undefined && this.loopIndex !== null) {
				return allPendingFiles.filter(
					(pendingFile) => pendingFile.loopIndex === this.loopIndex && pendingFile.fileType === this.fileType
				);
			}

			return allPendingFiles.filter((pendingFile) => pendingFile.fileType === this.fileType);
		},
		allPendingFiles() {
			const form = this.getFormKey();

			return this.$store.state.form.pendingFiles[form] || [];
		},
		processedUploadedFiles() {
			if (!this.uploadedFiles) {
				return [];
			}

			const form = this.getFormKey();

			const pendingDeletes = this.$store.state.form.pendingDeletes[form] || [];

			const isSpecialType = ["cpf", "address_partners", "representative"].includes(this.fileType);

			if (isSpecialType) {
				const { owner, representative } = this.$store.state.form.ownersAndContacts;
				const isRepresentative = this.fileType === "representative";
				const docList = isRepresentative ? representative : owner;
				const documentOrder = docList?.[this.loopIndex]?.documentOrder || [];
				const currentRef = this.$vnode.data.ref;

				const filteredFiles = this.uploadedFiles
					.map(file => {
						if (!documentOrder.length) return null;

						const matchedItem = documentOrder.find(item => {
							const indexMatch = (item.ownerIndex === this.loopIndex || item.representativeIndex === this.loopIndex);
							const formMatch = (item.form === currentRef || item.form === this.fileType);
							
							let fileTypeMatch = true;
							const fileFormType = file?.form || '';
							if (fileFormType === '') {
								fileTypeMatch = fileFormType === this.fileType;
							}

							return indexMatch && formMatch && file.name === item.name && fileTypeMatch;
						});

						return matchedItem ? file : null;
					})
					.filter(file => {
						if (!file) return false;

						const fileId = file.salesforceFileId || file.id;
						if (!fileId) return true;

						const isDeleted = pendingDeletes.some(deleteInfo => {
							const deleteId = deleteInfo.salesforceFileId || deleteInfo.file?.salesforceFileId;
							const loopIndexMatch =
								deleteInfo.loopIndex === this.loopIndex ||
								deleteInfo.loopIndex === undefined ||
								deleteInfo.loopIndex === null;
							return deleteId === fileId && loopIndexMatch;
						});

						return !isDeleted;
					});

				return filteredFiles.length > 0 ? filteredFiles : [];
			}

			return this.uploadedFiles.filter(file => {
				const salesforceFileId = file.salesforceFileId || file.id;
				if (!salesforceFileId) return true;

				const isDeleted = pendingDeletes.some(
					deleteInfo => {
						const deleteFileId = deleteInfo.salesforceFileId || deleteInfo.file?.salesforceFileId;
						return deleteFileId === salesforceFileId;
					}
				);
				return !isDeleted;
			});
		},
	},
};
</script>

<style lang="scss" scoped>
span {
	color: #686361;
	font-family: "Nunito Sans";
	font-size: 16px;
	letter-spacing: 0;
	line-height: 22px;
}

a {
	color: #007bff;
	font-family: "Montserrat";
	font-size: 14px;
	font-weight: bold;
	letter-spacing: 0;
	line-height: 18px;
	text-align: right;
	cursor: pointer;
}

small {
	display: block;
	color: #c2c0bf;
	font-family: "Nunito Sans";
	font-size: 12px;
	letter-spacing: 0;
	line-height: 16px;
	max-width: 90%;
}

.file {
	display: block;
	width: 100%;
	background-color: #f6f6f6;
	border-radius: 15px;
	color: #32302f;
	font-family: Montserrat;
	font-size: 14px;
	font-weight: bold;
	letter-spacing: 0;
	line-height: 18px;
	padding: 5px 25px;
	margin-bottom: 10px;
	position: relative;
}

.b-border {
	padding-bottom: 10px;
	margin: 30px 0;
	border-bottom: 1px solid #e7e7e7;
}

.delete {
	content: " ";
	top: 0px;
	right: 0px;
	width: 28px;
	z-index: 99;
	height: 100%;
	position: absolute;
	border-radius: 50%;
	background-color: #ed5417;
	cursor: pointer;
}

.delete::after {
	content: "−";
	color: white;
	position: absolute;
	font-weight: bold;
	margin-left: 0.6rem;
	margin-top: 0.35rem;
}

.mw-90 {
	max-width: 80%;
}

@media only screen and (max-width: 1024px) {
	span {
		font-size: 14px;
	}

	.delete::after {
		margin-left: 0.7rem;
	}
}
</style>
